import React from 'react';
import styled from 'styled-components';
import { UnstyledButton } from './Button';
import { Icon } from '../Icon';
import { OnClickFocusWrapper } from '../UtilityWrappers';
import { StyledDownArrowIcon } from '../Icon';
const StyledButton = styled(UnstyledButton) `
  display: flex;
  align-items: center;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
`;
const StyledRightArrowIcon = styled(Icon) `
  color: ${({ theme }) => theme.primaryBlack};
`;
const StyledDownArrow = styled(StyledButton) `
  padding: 0px 6px 0px 6px;
  transform: ${({ shouldImageFlip }) => (shouldImageFlip ? 'scale(-1, -1)' : 'none')};
  display: flex;
  align-items: center;
`;
const StyledLeftArrowIcon = styled(Icon) `
  color: ${({ theme }) => theme.secondaryBlue};
  left: -15px;
  position: absolute;
  font-size: 45px;
`;
const Arrow = ({ shouldImageFlip, onClick, direction, fontSize, disabled }) => {
    return direction === 'down' ? (React.createElement(OnClickFocusWrapper, null,
        React.createElement(StyledDownArrow, { type: "button", "aria-label": "down-arrow", shouldImageFlip: shouldImageFlip, onClick: onClick, disabled: disabled },
            React.createElement(StyledDownArrowIcon, { fontSize: fontSize }, "arrow_drop_down")))) : direction === 'left' ? (React.createElement(StyledButton, { type: "button", "aria-label": "side-arrow", onClick: onClick },
        React.createElement(StyledLeftArrowIcon, null, "chevron_left"))) : direction === 'right' ? (React.createElement(StyledButton, { type: "button", "aria-label": "side-arrow", onClick: onClick },
        React.createElement(StyledRightArrowIcon, null, "chevron_right"))) : null;
};
export { Arrow };
